<template>
  <el-table
    ref="tableRef"
    :data="tableData"
    v-loading="listLoading"
    border
    fit
    highlight-current-row
    style="width:100%"
    row-key="id"
    default-expand-all
    @selection-change="handleSelectionChange"
  >
    <el-table-column
      v-if="hadSelect"
      type="selection"
      :selectable="selectable"
      width="50"
    />
    <template
      :key="'t-column'+index"
      v-for="(item, index) in columnStruct.filter(c => !c.icon)"
    >
      <el-table-column
        v-if="item.canEdit"
        :prop="item.prop"
        :label="item.label"
        :width="item.width ? item.width : 190"
        :sortable="item.sortable"
        :formatter="item.formatter"
        header-align="left"
        :align="item.align"
        show-overflow-tooltip
      >
        <template
          #default="{row}"
        >
          <div class="container">
            <span
              v-if="item.formatter"
              :style="'overflow: hidden;text-overflow: ellipsis;width: ' + (item.width ? item.width - 55 : 135) + 'px'"
            >{{ item.formatter(row) }}</span>
            <span
              v-else
              :style="'overflow: hidden;text-overflow: ellipsis;width: ' + (item.width ? item.width - 55 : 135) + 'px'"
            >{{ row[item.prop] ? row[item.prop] : '' }}</span>
            <el-button
              v-if="item.notComplete(row)"
              @click="handleEdit(row, item.prop)"
              class="el-icon-edit-outline-button"
              type="primary"
              icon="el-icon-edit-outline"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-else
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :sortable="item.sortable"
        :formatter="item.formatter"
        header-align="left"
        :align="item.align"
        show-overflow-tooltip
      />
    </template>
    <el-table-column
      :key="'t-column-icon'+index"
      v-for="(item, index) in columnStruct.filter(c => c.icon)"
      :prop="item.prop"
      :label="item.label"
      :width="item.width ? item.width : 120"
      :sortable="item.sortable"
      :formatter="item.formatter"
      header-align="left"
      :align="item.align"
      show-overflow-tooltip
    >
      <template #default="{row}">
        <el-tooltip
          v-if="item.showIcon(row)"
          :content="row[item.iconTooltip]"
          placement="left-end"
        >
          <i
            style="font-size: 20px; color:#ff4949; padding-right: 5px;"
            :class="'el-icon-' + item.icon"
          />
        </el-tooltip>
        <span>{{ item.formatter(row) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="hadOperate"
      :label="t(operateText)"
      :width="operateColumnWidth"
      show-overflow-tooltip
    >
      <template #default="{row}">
        <slot
          :row="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElTable } from 'element-plus'

export default defineComponent({
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateText: {
      type: String,
      required: false,
      default: 'common.operate'
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    hadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    }
  },
  emits: ['custom-event'],
  methods: {
    handleEdit(row: any, itemProp: string) {
      this.$emit('custom-event', row, itemProp)
    }
  },
  setup() {
    const { t } = useI18n()
    const tableRef = ref(ElTable)
    const selectedRows = ref<any[]>([])

    const getSelectionRows = () => {
      return selectedRows.value || []
    }
    const clearSelection = () => {
      if (tableRef.value) {
        tableRef.value.clearSelection()
        selectedRows.value = []
      }
    }
    const handleSelectionChange = (val: any) => {
      selectedRows.value = val
    }
    return {
      t,
      tableRef,
      handleSelectionChange,
      getSelectionRows,
      clearSelection
    }
  }
})
</script>

<style scoped lang="scss">
.flex-container {
  display: flex;
  justify-content: flex-end; /* 将子元素（按钮）推向右侧 */
}

.container {
  display: flex;
  justify-content: space-between; /* 根据需要选择合适的对齐方式 */
  align-items: center; /* 垂直居中 */
}

.custom-button {
  padding: 5px 5px; /* 根据需要调整 */
  font-size: 20px; /* 根据需要调整 */
}
</style>
